// src/components/layout/Footer.jsx
// -----------------------------------------------------------------------------
// Simple app footer shown at the bottom of every authenticated page.
// -----------------------------------------------------------------------------
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <span>© {year}  AFix. All rights reserved.</span>
      <span>
        Track <span style={{ color: 'var(--afix-orange)' }}>.</span> Fix{' '}
        <span style={{ color: 'var(--afix-orange)' }}>.</span> Deliver
      </span>
    </footer>
  );
}
